import React, { useEffect, useState } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { USER_ROLES } from '../utils/roles';
import {
  FaHome,
  FaMoneyBillWave,
  FaChartBar,
  FaUser,
  FaCog,
  FaUsers,
  FaPiggyBank,
  FaSignOutAlt,
  FaBox
} from 'react-icons/fa';
import './Layout.css';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebaseconfig';

const Layout = () => {
  const logo = require('../assets/logo.jpeg');
  const location = useLocation();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const { userRole, logout } = useAuth();
  const isAdmin = userRole === USER_ROLES.ADMIN;
  const isManagerOrAdmin = userRole === USER_ROLES.ADMIN || userRole === USER_ROLES.MANAGER;
  const isStaff = userRole === USER_ROLES.STAFF;

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      if (firebaseUser) {
        setUser(firebaseUser);
      } else {
        setUser(null);
      }
    });
    return () => unsubscribe();
  }, []);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login', { replace: true });
    } catch (e) {
      // no-op; optional toast can be added
    }
  };

  // Define navigation items with role-based access
  const navigation = isAdmin
    ? [
        { path: '/dashboard', label: 'Dashboard', icon: <FaHome /> },
        { path: '/expenses', label: 'Expenses', icon: <FaMoneyBillWave /> },
        { path: '/stock', label: 'Stock', icon: <FaBox /> },
        { path: '/savings', label: 'Staff Savings', icon: <FaPiggyBank /> },
        { path: '/reports', label: 'Reports', icon: <FaChartBar /> },
        { path: '/users', label: 'Users', icon: <FaUsers /> },
        { path: '/profile', label: 'Profile', icon: <FaUser /> },
        { path: '/settings', label: 'Settings', icon: <FaCog /> }
      ]
    : isManagerOrAdmin
    ? [
        { path: '/expenses', label: 'Expenses', icon: <FaMoneyBillWave /> },
        { path: '/stock', label: 'Stock', icon: <FaBox /> },
        { path: '/savings', label: 'Staff Savings', icon: <FaPiggyBank /> },
        { path: '/profile', label: 'Profile', icon: <FaUser /> },
        { path: '/user-settings', label: 'Settings', icon: <FaCog /> }
      ]
    : isStaff
    ? [
        { path: '/staff-savings', label: 'My Savings', icon: <FaPiggyBank /> },
        { path: '/profile', label: 'Profile', icon: <FaUser /> },
        { path: '/user-settings', label: 'Settings', icon: <FaCog /> }
      ]
    : [
        { path: '/expenses', label: 'Expenses', icon: <FaMoneyBillWave /> },
        { path: '/stock', label: 'Stock', icon: <FaBox /> },
        { path: '/profile', label: 'Profile', icon: <FaUser /> },
        { path: '/user-settings', label: 'Settings', icon: <FaCog /> }
      ];

  return (
    <div className="layout">
      <aside className="sidebar">
        <div className="sidebar-header">
          <div style={{ display: 'flex-col', marginTop: '-10px', alignItems: 'center', justifyContent: 'space-between' }}>
            <a><img src={logo} alt="logo" style={{ width: '70px', height: '70px' }} /></a>
          </div>
        </div>
        <nav className="sidebar-nav">
          {navigation.map(item => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
            </Link>
          ))}
          <button type="button" onClick={handleLogout} className="nav-item nav-button">
            <span className="nav-icon"><FaSignOutAlt /></span>
            <span className="nav-label">Logout</span>
          </button>
        </nav>
      </aside>
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout; 